import React, { useState ,useEffect} from "react";
import { AiFillHome ,AiFillMessage} from "react-icons/ai";
import { FaUserAlt } from "react-icons/fa";
import { TbLogout } from "react-icons/tb";
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { RiAddBoxFill } from "react-icons/ri"
import axios from 'axios';
import {
  RiSendPlaneFill,
  RiSearchFill,
  RiNotification3Fill,
} from "react-icons/ri";
import { Outlet, useNavigate } from "react-router-dom";
import { ChatState } from "../assets/context";
// import { getSender } from "../assets/Chatlogix";
import {ENDPOINT} from "../assets/endpoint";
import CreatePost from "../components/Create Post/CreatePost"
function Navbar() {
  const history = useNavigate();
  // const [toProfile,setToprofile]=useState()
  const [searchBtn, setSearchBtn] = useState(false);
  const [notiBtn, setNotiBtn] = useState(false);
  const[search,setsearch] =  useState()
  const [SearchResult,setSearchResult] = useState()
const {user
,notification,setnotification,setSelectedChat,setClickedChat,createPost,setCreatepost} = ChatState()

  function ShowSearchBox() {
  if(search){
    if (searchBtn) {
      setsearch()
      setSearchBtn(false);
    } else {
      setsearch()
      setSearchBtn(true);
    }
  }else{
    if (searchBtn) {
      setSearchBtn(false);
    } else {
      setSearchBtn(true);
    }
  }
  }
  function ShowNotification() {
    if (notiBtn) {
      setNotiBtn(false);
    } else {
      setNotiBtn(true);
    }
  }

// SEARCH FUNCTION  
const SearchUser = async() =>{
  if(search){
      try {
        
          const {data} = await axios.post(`${ENDPOINT}/user?search=${search}`,{id:user._id})
          setSearchResult(data)

      } catch (error) {
          console.log(error);
      }
  }else{
      setSearchResult('')

  }
}
  useEffect(()=>{
      SearchUser()
  },[search])
/////////////


// function Gotoprofile(id){

//   setParams(id)
//   history(`/profile/?_id=${id}`)
  
// }




function Myprofile(data){
  history(`/profile/?id=${data._id}`)
  // setParams(data)
}

////////////

// LOGGING OUT USER 
const LoggingOut = () =>{
  history("/login")
  localStorage.removeItem("userData")
}

const DisplayCreateBox = () =>{
  if(createPost === false){

    setCreatepost(true)
  }else{
    setCreatepost(false)

  }
}

  return (
    <>
      {searchBtn  ? (
        <div
          className="navbar"
          style={{ alignItems: "center", width: "auto" }}
        >
          <div className="items">
            <div id="navbarsvg">
              <HiChatBubbleLeftRight />
            </div>
            <h1 style={{ display: "none" }}>Chat here</h1>
            <div className="item" onClick={() => history("/")}>
              
              <div className="item_icon">
                <AiFillHome />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Home</h3>
              </div>
            </div>
            <div className="item" onClick={ShowSearchBox}>
              
              <div className="item_icon">
                <RiSearchFill />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Search</h3>
                
              </div>
            </div>
            <div className="item" onClick={DisplayCreateBox}>
              
              <div className="item_icon" >
                <RiAddBoxFill />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Create</h3>
              </div>
            </div>
            <div className="item" onClick={() => history("/message")}>
              
              <div className="item_icon">
                <RiSendPlaneFill />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Messages</h3>
              </div>
            </div>
            <div className="item" onClick={ShowNotification}>
              
              <div className="item_icon">
                <RiNotification3Fill />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Notification</h3>
              </div>
            </div>
            <div className="item"
             onClick={()=>Myprofile(user)}
             >

              <div className="item_icon">
                <FaUserAlt />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Profile</h3>
              </div>
            </div>
            <div className="item" id="logout">

              <div className="item_icon">
                <TbLogout />
              </div>
              <div className="item_content" style={{ display: "none" }}>
                <h3>Log out</h3>
              </div>
            </div>
          </div>
          <div className="search_box">
            <h1>Search</h1>
            <div className="search_input">

              <input type="search" placeholder="Search"  value={search} 
  onChange={(e)=>{setsearch(e.target.value)}}/>
            </div>
            <div className="search_results">
              {SearchResult?(
                SearchResult.map((elem)=>{
                  return(
                    <div className="search_result_users" key={elem._id}              onClick={()=>Myprofile(elem)}
                    >
                        <div className="search_result_image">

                      <img src={elem.profilePicture} alt="Person"   />
                        </div>
                      <div className="search_text"
             onClick={()=>Myprofile(elem)}
             >

                      
                    <h3 >{elem.username}</h3>
                    <h4 >{elem.firstname + elem.lastname}</h4>
                    </div>
                 
                </div>
                  )
              })
              ):(
                <h5>Results...</h5>
              )}
          
            </div>
          </div>

        
        </div>
      ) : (
        <div className="navbar">
          <div className="items">
            <div id="navbarsvg">
              <HiChatBubbleLeftRight />
            </div>
            <h1>Chat here</h1>
            <div className="item" onClick={() => history("/")}>

              <div className="item_icon">
                <AiFillHome />
              </div>
              <div className="item_content">
                <h3>Home</h3>
              </div>
            </div>
            <div className="item" onClick={ShowSearchBox}>

              <div className="item_icon" >
                <RiSearchFill />
              </div>
              <div className="item_content">
                <h3>Search</h3>
              </div>
            </div>
            <div className="item" onClick={DisplayCreateBox}>
              
              <div className="item_icon">
                <RiAddBoxFill />
              </div>
              <div className="item_content" >
                <h3>Create</h3>
              </div>
            </div>
            <div className="item" onClick={() => {history("/message");setClickedChat(false)}}>

              <div className="item_icon">
                <RiSendPlaneFill />
              </div>
              <div className="item_content">
                <h3>Messages</h3>
              </div>
            </div>
            <div className="item" onClick={ShowNotification}>

              <div className="item_icon">
                <RiNotification3Fill />
              </div>
              <div className="item_content">
                <h3>Notification</h3>
              </div>
            </div>
            <div className="item"              onClick={()=>Myprofile(user)}
>

              <div className="item_icon">
                <FaUserAlt />
              </div>
              <div className="item_content" 
             >
                <h3>Profile</h3>
              </div>
            </div>
            <div className="item" id="logout">

              <div className="item_icon">
                <TbLogout />
              </div>
              <div className="item_content" onClick={LoggingOut}>
                <h3>Log out</h3>
              </div>
            </div>
          </div>
          {notiBtn?<div className="notifications">
            <h1>Notifications</h1>
            <div className="notification_message">
          {notification.length?(
            notification.map((noti)=>{
           return(
            <div className="notify_msgs"
            key={noti._id}
            onClick={()=>{
              setSelectedChat(noti.chat)
             setnotification(notification.filter((n)=> n !== noti))
            }}>
          
            </div>
           )
            })
          ):(
            <div className="notif_noMsg">
            <h3>No new message !</h3>
          </div>
          )}
      

      
            </div>
          </div>:""}
        </div>
      )}
      <Outlet />
      {createPost?
      <CreatePost DisplayCreateBox={DisplayCreateBox}/>
      :""
    }
    </>
  );
}

export default Navbar;
